import React from 'react';
import { ReactComponent as DocumentSVG } from './document.svg';

export default function DocumentIcon({width = 20, height = 20, color = '#007AFF'})
{
  return (
    <DocumentSVG
      width={width}
      height={height}
      style={{color: color}}
    />
  );
}